import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0e170ba0")

_pushScopeId("data-v-0e170ba0")
const _hoisted_1 = { class: "subtitle" }
const _hoisted_2 = { class: "scoreboxbig" }
const _hoisted_3 = { class: "score" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "fen" }, "分", -1)
const _hoisted_5 = { class: "scorebigtip" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "chartname" }, "24小时脉搏波变化图", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "chartname" }, "24小时Poincare散点图", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "chartname" }, "24小时活动分布图", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "chartname" }, "24小时心率分布图", -1)
const _hoisted_10 = { class: "tb" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "itme" }, [
  /*#__PURE__*/_createVNode("div", null, "检测指标"),
  /*#__PURE__*/_createVNode("div", null, "检测结果"),
  /*#__PURE__*/_createVNode("div", null, "提示"),
  /*#__PURE__*/_createVNode("div", null, "参考范围")
], -1)
const _hoisted_12 = {
  key: 0,
  class: "itme"
}
const _hoisted_13 = /*#__PURE__*/_createVNode("div", null, "XAR", -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode("↓")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("↑")
const _hoisted_16 = /*#__PURE__*/_createVNode("div", null, "76.62~84.36", -1)
const _hoisted_17 = {
  key: 1,
  class: "itme"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("div", null, "XST", -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode("↓")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("↑")
const _hoisted_21 = /*#__PURE__*/_createVNode("div", null, "5.9~8.3", -1)
const _hoisted_22 = {
  key: 2,
  class: "itme"
}
const _hoisted_23 = /*#__PURE__*/_createVNode("div", null, "XVLA", -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode("↓")
const _hoisted_25 = /*#__PURE__*/_createVNode("div", null, ">23", -1)
const _hoisted_26 = {
  key: 3,
  class: "itme"
}
const _hoisted_27 = /*#__PURE__*/_createVNode("div", null, "XASRD", -1)
const _hoisted_28 = /*#__PURE__*/_createTextVNode("↓")
const _hoisted_29 = /*#__PURE__*/_createVNode("div", null, ">13.0", -1)
const _hoisted_30 = {
  key: 4,
  class: "itme"
}
const _hoisted_31 = /*#__PURE__*/_createVNode("div", null, "XBAR", -1)
const _hoisted_32 = /*#__PURE__*/_createTextVNode("↓")
const _hoisted_33 = /*#__PURE__*/_createTextVNode("↑")
const _hoisted_34 = /*#__PURE__*/_createVNode("div", null, "130.0~270.0", -1)
const _hoisted_35 = {
  key: 5,
  class: "itme"
}
const _hoisted_36 = /*#__PURE__*/_createVNode("div", null, "XAAR", -1)
const _hoisted_37 = /*#__PURE__*/_createTextVNode("↓")
const _hoisted_38 = /*#__PURE__*/_createTextVNode("↑")
const _hoisted_39 = /*#__PURE__*/_createVNode("div", null, "160.0~420.0", -1)
const _hoisted_40 = {
  key: 6,
  class: "itme"
}
const _hoisted_41 = /*#__PURE__*/_createVNode("div", null, "GSA", -1)
const _hoisted_42 = /*#__PURE__*/_createTextVNode("↓")
const _hoisted_43 = /*#__PURE__*/_createVNode("div", null, "≥15.56", -1)
const _hoisted_44 = {
  key: 7,
  class: "itme"
}
const _hoisted_45 = /*#__PURE__*/_createVNode("div", null, "GLA", -1)
const _hoisted_46 = /*#__PURE__*/_createTextVNode("↓")
const _hoisted_47 = /*#__PURE__*/_createVNode("div", null, ">80.61", -1)
const _hoisted_48 = {
  key: 8,
  class: "itme"
}
const _hoisted_49 = /*#__PURE__*/_createVNode("div", null, "GSDA", -1)
const _hoisted_50 = /*#__PURE__*/_createTextVNode("↓")
const _hoisted_51 = /*#__PURE__*/_createVNode("div", null, ">870.0", -1)
const _hoisted_52 = {
  key: 9,
  class: "itme"
}
const _hoisted_53 = /*#__PURE__*/_createVNode("div", null, "SVL", -1)
const _hoisted_54 = /*#__PURE__*/_createTextVNode("↓")
const _hoisted_55 = /*#__PURE__*/_createVNode("div", null, ">93.0", -1)
const _hoisted_56 = {
  key: 10,
  class: "itme"
}
const _hoisted_57 = /*#__PURE__*/_createVNode("div", null, "SMR", -1)
const _hoisted_58 = /*#__PURE__*/_createTextVNode("↓")
const _hoisted_59 = /*#__PURE__*/_createTextVNode("↑")
const _hoisted_60 = /*#__PURE__*/_createVNode("div", null, "65.0~79.0", -1)
const _hoisted_61 = {
  key: 11,
  class: "itme"
}
const _hoisted_62 = /*#__PURE__*/_createVNode("div", null, "XMA", -1)
const _hoisted_63 = /*#__PURE__*/_createTextVNode("↓")
const _hoisted_64 = /*#__PURE__*/_createVNode("div", null, ">12.3", -1)
const _hoisted_65 = {
  key: 12,
  class: "itme"
}
const _hoisted_66 = /*#__PURE__*/_createVNode("div", null, "XSB", -1)
const _hoisted_67 = /*#__PURE__*/_createTextVNode("↑")
const _hoisted_68 = /*#__PURE__*/_createVNode("div", null, "≤2.0", -1)
const _hoisted_69 = {
  key: 13,
  class: "itme"
}
const _hoisted_70 = /*#__PURE__*/_createVNode("div", null, "GTH", -1)
const _hoisted_71 = /*#__PURE__*/_createTextVNode("↓")
const _hoisted_72 = /*#__PURE__*/_createTextVNode("↑")
const _hoisted_73 = /*#__PURE__*/_createVNode("div", null, "10.7~18.8", -1)
const _hoisted_74 = {
  key: 14,
  class: "itme"
}
const _hoisted_75 = /*#__PURE__*/_createVNode("div", null, "GBR", -1)
const _hoisted_76 = /*#__PURE__*/_createTextVNode("↑")
const _hoisted_77 = /*#__PURE__*/_createVNode("div", null, "≤270.0", -1)
const _hoisted_78 = {
  key: 15,
  class: "itme"
}
const _hoisted_79 = /*#__PURE__*/_createVNode("div", null, "GAR", -1)
const _hoisted_80 = /*#__PURE__*/_createTextVNode("↑")
const _hoisted_81 = /*#__PURE__*/_createVNode("div", null, "≤420.0", -1)
const _hoisted_82 = {
  key: 16,
  class: "itme"
}
const _hoisted_83 = /*#__PURE__*/_createVNode("div", null, "PAR", -1)
const _hoisted_84 = /*#__PURE__*/_createTextVNode("↑")
const _hoisted_85 = /*#__PURE__*/_createVNode("div", null, "≤650.0", -1)
const _hoisted_86 = {
  key: 17,
  class: "itme"
}
const _hoisted_87 = /*#__PURE__*/_createVNode("div", null, "SMPSC", -1)
const _hoisted_88 = /*#__PURE__*/_createTextVNode("↓")
const _hoisted_89 = /*#__PURE__*/_createVNode("div", null, "≥60.0", -1)
const _hoisted_90 = {
  key: 18,
  class: "itme"
}
const _hoisted_91 = /*#__PURE__*/_createVNode("div", null, "PSMPSC", -1)
const _hoisted_92 = /*#__PURE__*/_createTextVNode("↓")
const _hoisted_93 = /*#__PURE__*/_createVNode("div", null, "≥60.0", -1)
const _hoisted_94 = {
  key: 19,
  class: "itme"
}
const _hoisted_95 = /*#__PURE__*/_createVNode("div", null, "BMI", -1)
const _hoisted_96 = /*#__PURE__*/_createTextVNode("↓")
const _hoisted_97 = /*#__PURE__*/_createTextVNode("↑")
const _hoisted_98 = /*#__PURE__*/_createVNode("div", null, "18.5~23.9", -1)
const _hoisted_99 = { class: "codetxt" }
const _hoisted_100 = /*#__PURE__*/_createVNode("div", { class: "name" }, "评估结果", -1)
const _hoisted_101 = { class: "val" }
const _hoisted_102 = { class: "codetxt" }
const _hoisted_103 = /*#__PURE__*/_createVNode("div", { class: "name" }, "常见症状", -1)
const _hoisted_104 = { class: "val" }
const _hoisted_105 = { class: "codetxt" }
const _hoisted_106 = /*#__PURE__*/_createVNode("div", { class: "name" }, "好发疾病", -1)
const _hoisted_107 = { class: "val" }
const _hoisted_108 = { class: "codetxt" }
const _hoisted_109 = /*#__PURE__*/_createVNode("div", { class: "name" }, "调理建议", -1)
const _hoisted_110 = { class: "val" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ScoreNum = _resolveComponent("ScoreNum")

  return (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data, (item) => {
    return (_openBlock(), _createBlock("div", {
      class: "card",
      key: item.id
    }, [
      _createVNode("div", _hoisted_1, _toDisplayString(_ctx.dataTypeNemeList[item.dataType - 1]), 1),
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_ScoreNum, {
            score: parseInt(item.score),
            addZero: true
          }, null, 8, ["score"])
        ]),
        _hoisted_4
      ]),
      _createVNode("div", _hoisted_5, _toDisplayString(item.requali), 1),
      (_ctx.pulseCurveUrl && ((_ctx.dataTypeNemeList[item.dataType - 1] === '心血管功能测评') || _ctx.dataTypeNemeList[item.dataType - 1] === '心理状态测评'))
        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
            _createVNode("img", {
              class: "chartimg",
              src: _ctx.pulseCurveUrl,
              alt: "24小时脉搏波变化图"
            }, null, 8, ["src"]),
            _hoisted_6
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.poincareUrl && (_ctx.dataTypeNemeList[item.dataType - 1] === '心血管功能测评'))
        ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
            _createVNode("img", {
              class: "chartimg",
              src: _ctx.poincareUrl,
              alt: "24小时Poincare散点图"
            }, null, 8, ["src"]),
            _hoisted_7
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.pmCurveUrl && (_ctx.dataTypeNemeList[item.dataType - 1] === '心血管功能测评'))
        ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
            _createVNode("img", {
              class: "chartimg",
              src: _ctx.pmCurveUrl,
              alt: "24小时活动分布图"
            }, null, 8, ["src"]),
            _hoisted_8
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.ecgCurveUrl && ((_ctx.dataTypeNemeList[item.dataType - 1] === '心血管功能测评') || (_ctx.dataTypeNemeList[item.dataType - 1] === '寒热状态测评')))
        ? (_openBlock(), _createBlock(_Fragment, { key: 3 }, [
            _createVNode("img", {
              class: "chartimg",
              src: _ctx.ecgCurveUrl,
              alt: "24小时心率分布图"
            }, null, 8, ["src"]),
            _hoisted_9
          ], 64))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_10, [
        _hoisted_11,
        (_ctx.getHasCode(item.dataType).hasXarList)
          ? (_openBlock(), _createBlock("div", _hoisted_12, [
              _hoisted_13,
              _createVNode("div", null, _toDisplayString(Math.floor(_ctx.codeList[0].xar * 100) / 100), 1),
              _createVNode("div", null, [
                (Number(_ctx.codeList[0].xar) < 76.62)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _hoisted_14
                    ], 64))
                  : _createCommentVNode("", true),
                (Number(_ctx.codeList[0].xar) > 84.36)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                      _hoisted_15
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_16
            ]))
          : _createCommentVNode("", true),
        (_ctx.getHasCode(item.dataType).hasXstList)
          ? (_openBlock(), _createBlock("div", _hoisted_17, [
              _hoisted_18,
              _createVNode("div", null, _toDisplayString(Math.floor(_ctx.codeList[0].xst * 100) / 100), 1),
              _createVNode("div", null, [
                (Number(_ctx.codeList[0].xst) < 5.9)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _hoisted_19
                    ], 64))
                  : _createCommentVNode("", true),
                (Number(_ctx.codeList[0].xst) > 8.3)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                      _hoisted_20
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_21
            ]))
          : _createCommentVNode("", true),
        (_ctx.getHasCode(item.dataType).hasXvlaList)
          ? (_openBlock(), _createBlock("div", _hoisted_22, [
              _hoisted_23,
              _createVNode("div", null, _toDisplayString(Math.floor(_ctx.codeList[0].xvla * 100) / 100), 1),
              _createVNode("div", null, [
                (Number(_ctx.codeList[0].xvla) <= 23)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _hoisted_24
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_25
            ]))
          : _createCommentVNode("", true),
        (_ctx.getHasCode(item.dataType).hasXasrdList)
          ? (_openBlock(), _createBlock("div", _hoisted_26, [
              _hoisted_27,
              _createVNode("div", null, _toDisplayString(Math.floor(_ctx.codeList[0].xasrd * 100) / 100), 1),
              _createVNode("div", null, [
                (Number(_ctx.codeList[0].xasrd) <= 13.0)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _hoisted_28
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_29
            ]))
          : _createCommentVNode("", true),
        (_ctx.getHasCode(item.dataType).hasXbarList)
          ? (_openBlock(), _createBlock("div", _hoisted_30, [
              _hoisted_31,
              _createVNode("div", null, _toDisplayString(Math.floor(_ctx.codeList[0].xbar * 100) / 100), 1),
              _createVNode("div", null, [
                (Number(_ctx.codeList[0].xbar) < 130)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _hoisted_32
                    ], 64))
                  : _createCommentVNode("", true),
                (Number(_ctx.codeList[0].xbar) > 270)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                      _hoisted_33
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_34
            ]))
          : _createCommentVNode("", true),
        (_ctx.getHasCode(item.dataType).hasXaarList)
          ? (_openBlock(), _createBlock("div", _hoisted_35, [
              _hoisted_36,
              _createVNode("div", null, _toDisplayString(Math.floor(_ctx.codeList[0].xaar * 100) / 100), 1),
              _createVNode("div", null, [
                (Number(_ctx.codeList[0].xaar) < 160.0)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _hoisted_37
                    ], 64))
                  : _createCommentVNode("", true),
                (Number(_ctx.codeList[0].xaar) > 420.0)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                      _hoisted_38
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_39
            ]))
          : _createCommentVNode("", true),
        (_ctx.getHasCode(item.dataType).hasGasList)
          ? (_openBlock(), _createBlock("div", _hoisted_40, [
              _hoisted_41,
              _createVNode("div", null, _toDisplayString(Math.floor(_ctx.codeList[0].gsa * 100) / 100), 1),
              _createVNode("div", null, [
                (Number(_ctx.codeList[0].gsa) < 15.56)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _hoisted_42
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_43
            ]))
          : _createCommentVNode("", true),
        (_ctx.getHasCode(item.dataType).hasGlaList)
          ? (_openBlock(), _createBlock("div", _hoisted_44, [
              _hoisted_45,
              _createVNode("div", null, _toDisplayString(Math.floor(_ctx.codeList[0].gla * 100) / 100), 1),
              _createVNode("div", null, [
                (Number(_ctx.codeList[0].gla) <= 80.61)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _hoisted_46
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_47
            ]))
          : _createCommentVNode("", true),
        (_ctx.getHasCode(item.dataType).hasGsdaList)
          ? (_openBlock(), _createBlock("div", _hoisted_48, [
              _hoisted_49,
              _createVNode("div", null, _toDisplayString(Math.floor(_ctx.codeList[0].gsda * 100) / 100), 1),
              _createVNode("div", null, [
                (Number(_ctx.codeList[0].gsda) <= 870.0)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _hoisted_50
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_51
            ]))
          : _createCommentVNode("", true),
        (_ctx.getHasCode(item.dataType).hasSvlList)
          ? (_openBlock(), _createBlock("div", _hoisted_52, [
              _hoisted_53,
              _createVNode("div", null, _toDisplayString(Math.floor(_ctx.codeList[0].svl * 100) / 100), 1),
              _createVNode("div", null, [
                (Number(_ctx.codeList[0].svl) <= 93.0)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _hoisted_54
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_55
            ]))
          : _createCommentVNode("", true),
        (_ctx.getHasCode(item.dataType).hasSmrList)
          ? (_openBlock(), _createBlock("div", _hoisted_56, [
              _hoisted_57,
              _createVNode("div", null, _toDisplayString(Math.floor(_ctx.codeList[0].smr * 100) / 100), 1),
              _createVNode("div", null, [
                (Number(_ctx.codeList[0].smr) < 65.0)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _hoisted_58
                    ], 64))
                  : _createCommentVNode("", true),
                (Number(_ctx.codeList[0].smr) > 79.0)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                      _hoisted_59
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_60
            ]))
          : _createCommentVNode("", true),
        (_ctx.getHasCode(item.dataType).hasXmaList)
          ? (_openBlock(), _createBlock("div", _hoisted_61, [
              _hoisted_62,
              _createVNode("div", null, _toDisplayString(_ctx.codeList[0].xma ? (Math.floor(_ctx.codeList[0].xma * 100) / 100) : 0.0), 1),
              _createVNode("div", null, [
                (Number(_ctx.codeList[0].xma) < 12.3)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _hoisted_63
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_64
            ]))
          : _createCommentVNode("", true),
        (_ctx.getHasCode(item.dataType).hasXsbList)
          ? (_openBlock(), _createBlock("div", _hoisted_65, [
              _hoisted_66,
              _createVNode("div", null, _toDisplayString(_ctx.codeList[0].xsb ? (Math.floor(_ctx.codeList[0].xsb * 100) / 100) : 0.0), 1),
              _createVNode("div", null, [
                (Number(_ctx.codeList[0].xsb) > 2)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _hoisted_67
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_68
            ]))
          : _createCommentVNode("", true),
        (_ctx.getHasCode(item.dataType).hasGthList)
          ? (_openBlock(), _createBlock("div", _hoisted_69, [
              _hoisted_70,
              _createVNode("div", null, _toDisplayString(_ctx.codeList[0].gth ? (Math.floor(_ctx.codeList[0].gth * 100) / 100) : 0.0), 1),
              _createVNode("div", null, [
                (Number(_ctx.codeList[0].gth) < 10.7)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _hoisted_71
                    ], 64))
                  : _createCommentVNode("", true),
                (Number(_ctx.codeList[0].gth) > 18.8)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                      _hoisted_72
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_73
            ]))
          : _createCommentVNode("", true),
        (_ctx.getHasCode(item.dataType).hasGbrList)
          ? (_openBlock(), _createBlock("div", _hoisted_74, [
              _hoisted_75,
              _createVNode("div", null, _toDisplayString(_ctx.codeList[0].gbr ? (Math.floor(_ctx.codeList[0].gbr * 100) / 100) : 0.0), 1),
              _createVNode("div", null, [
                (Number(_ctx.codeList[0].gbr) > 270.0)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _hoisted_76
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_77
            ]))
          : _createCommentVNode("", true),
        (_ctx.getHasCode(item.dataType).hasGarList)
          ? (_openBlock(), _createBlock("div", _hoisted_78, [
              _hoisted_79,
              _createVNode("div", null, _toDisplayString(_ctx.codeList[0].gar ? (Math.floor(_ctx.codeList[0].gar * 100) / 100) : 0.0), 1),
              _createVNode("div", null, [
                (Number(_ctx.codeList[0].gar) > 420.0)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _hoisted_80
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_81
            ]))
          : _createCommentVNode("", true),
        (_ctx.getHasCode(item.dataType).hasParList)
          ? (_openBlock(), _createBlock("div", _hoisted_82, [
              _hoisted_83,
              _createVNode("div", null, _toDisplayString(_ctx.codeList[0].par ? (Math.floor(_ctx.codeList[0].par * 100) / 100) : 0.0), 1),
              _createVNode("div", null, [
                (Number(_ctx.codeList[0].par) > 650.0)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _hoisted_84
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_85
            ]))
          : _createCommentVNode("", true),
        (_ctx.getHasCode(item.dataType).hasSmpscList)
          ? (_openBlock(), _createBlock("div", _hoisted_86, [
              _hoisted_87,
              _createVNode("div", null, _toDisplayString(_ctx.codeList[0].smpsc ? (Math.floor(_ctx.codeList[0].smpsc * 100) / 100) : 0.0), 1),
              _createVNode("div", null, [
                (Number(_ctx.codeList[0].smpsc) < 60.0)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _hoisted_88
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_89
            ]))
          : _createCommentVNode("", true),
        (_ctx.getHasCode(item.dataType).hasPsmpscList)
          ? (_openBlock(), _createBlock("div", _hoisted_90, [
              _hoisted_91,
              _createVNode("div", null, _toDisplayString(_ctx.codeList[0].psmpsc ? (Math.floor(_ctx.codeList[0].psmpsc * 100) / 100) : 0.0), 1),
              _createVNode("div", null, [
                (Number(_ctx.codeList[0].psmpsc) < 60.0)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _hoisted_92
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_93
            ]))
          : _createCommentVNode("", true),
        (_ctx.getHasCode(item.dataType).hasBmiList)
          ? (_openBlock(), _createBlock("div", _hoisted_94, [
              _hoisted_95,
              _createVNode("div", null, _toDisplayString(_ctx.codeList[0].bmi ? (Math.floor(_ctx.codeList[0].bmi * 100) / 100) : 0.0), 1),
              _createVNode("div", null, [
                (Number(_ctx.codeList[0].bmi) < 18.5)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _hoisted_96
                    ], 64))
                  : _createCommentVNode("", true),
                (Number(_ctx.codeList[0].bmi) > 23.9)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                      _hoisted_97
                    ], 64))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_98
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_99, [
        _hoisted_100,
        _createVNode("span", _hoisted_101, _toDisplayString(item.requali), 1)
      ]),
      _createVNode("div", _hoisted_102, [
        _hoisted_103,
        _createVNode("span", _hoisted_104, _toDisplayString(item.symptom), 1)
      ]),
      _createVNode("div", _hoisted_105, [
        _hoisted_106,
        _createVNode("span", _hoisted_107, _toDisplayString(item.warning), 1)
      ]),
      _createVNode("div", _hoisted_108, [
        _hoisted_109,
        _createVNode("span", _hoisted_110, _toDisplayString(item.suggestion), 1)
      ])
    ]))
  }), 128))
})